module.exports = __webpack_public_path__ + "img/paso2.bc185444.png";